import React, { useEffect, useMemo, useState } from 'react';
import styles from '../deal.module.css';
import { textStyles } from '../../../../constants/textStyles';
import formatNumber from '../../../../utils/formatNumber';
import {
  BANKS,
  DEAL_STATUS_WAITING_FOR_PAYMENT,
  DEAL_STEPS,
  DOCUMENT_TYPES_GUARANTEE_LETTER,
  DOCUMENT_TYPES_INVOICE,
  DOCUMENT_TYPES_PAYMENT_CONFIRMATION,
  DOCUMENT_TYPES_PAYMENT_ORDER,
  PAYMENT_STATUS_PAID,
  PAYMENT_TYPES_CREDIT_CARD,
  PAYMENT_TYPES_CREDIT_INVOICE,
  PAYMENT_TYPES_PREPAYMENT_CARD,
  PAYMENT_TYPES_PREPAYMENT_INVOICE,
} from '../../../../constants';
import { colors } from '../../../../constants/colors';
import ChosenBankConditions from './ChosenBankConditions';
import DealCarModal from '../../../../components/Modals/DealCarModal';
import ButtonDelete from '../../../../components/Button/ButtonDelete';
import removeItemsToDeal from '../../../../api/deals/removeItemsToDeal';
import DocumentList from './DocumentsList';
import formatDate from '../../../../utils/formatDate';
import HalykGetGuaranteeLetter from '../HalykFlow/HalykGetGuaranteeLetter';
import CheckBankStatus from '../CommonBankSteps/CheckBankStatus';
import Button from '../../../../components/Button/Button';
import DealConfigureSteps from '../../DealConfigureSteps';
import RejectDealModal from '../../RejectDealModal';
import DealHistoryModal from './DealHistoryModal';
import ProcessDocumentButton from '../../../../components/ProcessDocumentButton/ProcessDocumentButton';
import BankAppealsCancelBlock from '../../../../components/BankAppealsCancelBlock';
import { BANK_CREDIT_WAITING } from '../../../../constants/bankCreditStatuses';
import { MARITAL_STATUSES } from '../../../../components/Selects/SelectFamilyStatus';
import ShinhanQRCode from '../ShinhanFlow/ShinhanQRCode';
import { withoutExtraSteps } from '../greySteps';

const DealCreationSteps = ({
  currentStep,
  setCurrentStep,
  state,
  sum,
  deal,
  equipments,
  services,
  cars,
  removeEquipment,
  removeService,
  documents,
  chosenBankId,
  chosenBankAppealId,
  chosenBankAppeal,
  update,
  creditAppeals,
}) => {
  const [open, setOpen] = useState(false);
  const [containerId, setContainerId] = useState('');
  const [steps, setSteps] = useState([]);

  const showHalykGetGuaranteeLetterButton = useMemo(() => {
    return chosenBankId === BANKS.HALYK;
  }, [chosenBankId, documents]);

  const isEurazChosen = useMemo(() => {
    return chosenBankId === BANKS.EURAZ;
  }, [chosenBankId]);


  const showForteUpdateButton = useMemo(() => {
    return deal?.paymentType?.id == PAYMENT_TYPES_CREDIT_INVOICE && deal?.paymentType?.id == PAYMENT_TYPES_CREDIT_CARD;
    // const isGuaranteeLetterPresent = documents?.some((item) => item?.typeId === DOCUMENT_TYPES_PAYMENT_ORDER);
    // return chosenBankId === BANKS.FORTE && !isGuaranteeLetterPresent;
  }, [deal]);


  const creditAppeal = useMemo(() => {
    try {
      const json = JSON.parse(deal?.creditAppeal?.json || creditAppeals?.[0]?.json);
      return {
        ...json,
        createdAt: creditAppeals?.[0]?.createdAt,
      };
    } catch (e) {
      return null;
    }
  }, [deal, creditAppeals]);

  useEffect(() => {
    let newSteps =
      deal?.paymentType?.id === PAYMENT_TYPES_CREDIT_CARD || deal?.paymentType?.id === PAYMENT_TYPES_CREDIT_INVOICE
        ? [
            {
              title: 'ÐÑÐ½Ð¾Ð²Ð½Ð°Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ',
              subSteps: [1],
            },
            {
              title: 'ÐÐ¾Ð¿.Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ðµ',
              subSteps: [2],
            },
            {
              title: 'ÐÐ¾Ð¿.ÑÑÐ»ÑÐ³Ð¸',
              subSteps: [3],
            },
            {
              title: 'Ð£ÑÐ¾ÑÐ½ÐµÐ½Ð¸Ðµ Ð´Ð°Ð½Ð½ÑÑ',
              subSteps: [4],
            },
            {
              title: 'ÐÐ°Ð½Ðº',
              subSteps: [5],
            },
            {
              title: 'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ',
              subSteps: [6],
            },
            {
              title: 'Ð ÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ Ð·Ð°Ð»Ð¾Ð³Ð°',
              subSteps: [7],
            },
          ]
        : [
            {
              title: 'ÐÑÐ½Ð¾Ð²Ð½Ð°Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ',
              subSteps: [1],
            },
            {
              title: 'ÐÐ¾Ð¿.Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ðµ',
              subSteps: [2],
            },
            {
              title: 'ÐÐ¾Ð¿.ÑÑÐ»ÑÐ³Ð¸',
              subSteps: [3],
            },
            {
              title: 'ÐÐ¿Ð»Ð°ÑÐ°',
              subSteps: [4],
            },
            {
              title: 'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ',
              subSteps: [5],
            },
            {
              title: 'Ð ÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ Ð¢Ð¡',
              subSteps: [6],
            },
          ];

    if (chosenBankId === BANKS.FREEDOM) {
      newSteps = [
        {
          title: 'ÐÑÐ½Ð¾Ð²Ð½Ð°Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ',
          subSteps: [1],
        },
        {
          title: 'ÐÐ¾Ð¿.Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ðµ',
          subSteps: [2],
        },
        {
          title: 'ÐÐ¾Ð¿.ÑÑÐ»ÑÐ³Ð¸',
          subSteps: [3],
        },
        {
          title: 'Ð£ÑÐ¾ÑÐ½ÐµÐ½Ð¸Ðµ Ð´Ð°Ð½Ð½ÑÑ',
          subSteps: [4],
        },
        {
          title: 'ÐÐ°Ð½Ðº',
          subSteps: [5],
        },
        {
          title: 'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ',
          subSteps: [
            DEAL_STEPS.FREEDOM.SIGN_CONTRACT,
            DEAL_STEPS.FREEDOM.WAITING_FOR_CLIENT_ACTIONS_ON_FREEDOM_SITE,
            DEAL_STEPS.FREEDOM.WAITING_FOR_CLIENT_DOCUMENTS,
            DEAL_STEPS.FREEDOM.WAITING_FOR_PAYMENT,
            DEAL_STEPS.FREEDOM.AUTO_REGISTRATION,
            DEAL_STEPS.FREEDOM.WAITING_FOR_FINAL_ACTIONS,
            DEAL_STEPS.FORTE.AUTO_REGISTRATION,
            DEAL_STEPS.FORTE.NOTARIAL_VERIFICATION,
            DEAL_STEPS.FORTE.WAITING_FOR_CLIENT_DOCUMENTS,
            DEAL_STEPS.FORTE.WAITING_FOR_FINAL_ACTIONS,
            DEAL_STEPS.FORTE.WAITING_FOR_PAYMENT,
            DEAL_STEPS.CLIENT_PAYMENT_APPROVE,
          ],
        },
        {
          title: 'ÐÑÐ´Ð°ÑÐ° Ð¢Ð¡',
          subSteps: [DEAL_STEPS.FREEDOM.WAITING_FOR_FINAL_ACTIONS, DEAL_STEPS.FORTE.CAR_DELIVERY],
        },
      ];
    }
    if (chosenBankId === BANKS.FORTE) {
      newSteps = [
        {
          title: 'ÐÑÐ½Ð¾Ð²Ð½Ð°Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ',
          subSteps: [1],
        },
        {
          title: 'ÐÐ¾Ð¿.Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ðµ',
          subSteps: [2],
        },
        {
          title: 'ÐÐ¾Ð¿.ÑÑÐ»ÑÐ³Ð¸',
          subSteps: [3],
        },
        {
          title: 'Ð£ÑÐ¾ÑÐ½ÐµÐ½Ð¸Ðµ Ð´Ð°Ð½Ð½ÑÑ',
          subSteps: [4],
        },
        {
          title: 'ÐÐ°Ð½Ðº',
          subSteps: [5],
        },
        {
          title: 'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ',
          subSteps: [
            DEAL_STEPS.FORTE.AUTO_REGISTRATION,
            DEAL_STEPS.FORTE.NOTARIAL_VERIFICATION,
            DEAL_STEPS.FORTE.WAITING_FOR_CLIENT_DOCUMENTS,
            DEAL_STEPS.FORTE.WAITING_FOR_FINAL_ACTIONS,
            DEAL_STEPS.FORTE.WAITING_FOR_PAYMENT,
            DEAL_STEPS.FORTE.AUTO_REREGISTRATION,
            DEAL_STEPS.FORTE.WAITING_FOR_CLIENT_ACTIONS_ON_FORTE_SIDE,
            DEAL_STEPS.FORTE.SIGN_CONTRACT,
          ],
        },
        {
          title: 'ÐÑÐ´Ð°ÑÐ° Ð¢Ð¡',
          subSteps: [DEAL_STEPS.FORTE.WAITING_FOR_CLIENT_ACTIONS_ON_FORTE_MOBILE_APP],
        },
      ];
    }
    if (chosenBankId === BANKS.HALYK) {
      newSteps = [
        {
          title: 'ÐÑÐ½Ð¾Ð²Ð½Ð°Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ',
          subSteps: [1],
        },
        {
          title: 'ÐÐ¾Ð¿.Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ðµ',
          subSteps: [2],
        },
        {
          title: 'ÐÐ¾Ð¿.ÑÑÐ»ÑÐ³Ð¸',
          subSteps: [3],
        },
        {
          title: 'Ð£ÑÐ¾ÑÐ½ÐµÐ½Ð¸Ðµ Ð´Ð°Ð½Ð½ÑÑ',
          subSteps: [4],
        },
        {
          title: 'ÐÐ°Ð½Ðº',
          subSteps: [5],
        },
        {
          title: 'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ',
          subSteps: [
            DEAL_STEPS.HALYK.NOTARIAL_VERIFICATION,
            DEAL_STEPS.HALYK.WAITING_FOR_PAYMENT,
            DEAL_STEPS.HALYK.AUTO_REGISTRATION,
            DEAL_STEPS.HALYK.WAITING_FOR_FINAL_ACTIONS,
            DEAL_STEPS.CLIENT_PAYMENT_APPROVE,
          ],
        },
        {
          title: 'ÐÑÐ´Ð°ÑÐ° Ð¢Ð¡',
          subSteps: [DEAL_STEPS.HALYK.CAR_DELIVERY],
        },
      ];
    }
    if (chosenBankId === BANKS.HALYK) {
      newSteps = [
        {
          title: 'ÐÑÐ½Ð¾Ð²Ð½Ð°Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ',
          subSteps: [1],
        },
        {
          title: 'ÐÐ¾Ð¿.Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ðµ',
          subSteps: [2],
        },
        {
          title: 'ÐÐ¾Ð¿.ÑÑÐ»ÑÐ³Ð¸',
          subSteps: [3],
        },
        {
          title: 'Ð£ÑÐ¾ÑÐ½ÐµÐ½Ð¸Ðµ Ð´Ð°Ð½Ð½ÑÑ',
          subSteps: [4],
        },
        {
          title: 'ÐÐ°Ð½Ðº',
          subSteps: [5],
        },
        {
          title: 'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ',
          subSteps: [DEAL_STEPS.BEREKE.WAITING_FOR_CLIENT_ACTIONS],
        },
        {
          title: 'ÐÑÐ´Ð°ÑÐ° Ð¢Ð¡',
          subSteps: [DEAL_STEPS.BEREKE.CAR_DELIVERY],
        },
      ];
    }

    // Solva: Ð·Ð°Ð»Ð¾Ð³Ð¾Ð²ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð² Ð½ÐµÑ, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð²Ð¼ÐµÑÑÐ¾ Â«Ð ÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ð¸ Ð·Ð°Ð»Ð¾Ð³Ð°Â» â
    // ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ Ð¢Ð¡ Ð¸ Ð²ÑÐ´Ð°ÑÐ°. ÐÐÐ Ð¿Ð¾Ð´Ð¿Ð¸ÑÑÐ²Ð°ÐµÑÑÑ Ð½Ð° Ð¾Ð±ÑÐµÐ¼ ÑÐ°Ð³Ðµ SIGN_CONTRACT,
    // Ð¾Ð½ Ð¾ÑÐ½Ð¾ÑÐ¸ÑÑÑ Ðº Â«ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÐ°Ð¼Â».
    if (chosenBankId === BANKS.SOLVA) {
      newSteps = [
        {
          title: 'ÐÑÐ½Ð¾Ð²Ð½Ð°Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ',
          subSteps: [1],
        },
        {
          title: 'ÐÐ¾Ð¿.Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ðµ',
          subSteps: [2],
        },
        {
          title: 'ÐÐ¾Ð¿.ÑÑÐ»ÑÐ³Ð¸',
          subSteps: [3],
        },
        {
          title: 'Ð£ÑÐ¾ÑÐ½ÐµÐ½Ð¸Ðµ Ð´Ð°Ð½Ð½ÑÑ',
          subSteps: [4],
        },
        {
          title: 'ÐÐ°Ð½Ðº',
          subSteps: [5],
        },
        {
          title: 'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ',
          subSteps: [DEAL_STEPS.SIGN_CONTRACT, DEAL_STEPS.NOTARIAL_DOCUMENTS],
        },
        {
          title: 'Ð ÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ Ð¢Ð¡',
          subSteps: [DEAL_STEPS.SOLVA.AUTO_REGISTRATION],
        },
        {
          title: 'ÐÑÐ´Ð°ÑÐ° Ð¢Ð¡',
          subSteps: [DEAL_STEPS.SOLVA.CAR_DELIVERY],
        },
      ];
    }

    newSteps.forEach((item) => {
      if (item.title === 'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ' && !item.subSteps.includes(DEAL_STEPS.TRIPARTITE_CONTRACT)) {
        item.subSteps = [DEAL_STEPS.TRIPARTITE_CONTRACT, ...item.subSteps];
      }
    });
    setSteps(withoutExtraSteps(newSteps));
  }, [chosenBankId, deal]);

  const navigateToClient = (id) => {
    window.open(`/client/${id}/main-data`, '_blank');
  };

  const openCarModal = (containerId) => {
    setContainerId(containerId);
    setOpen(true);
  };

  const closeCarModal = () => {
    setOpen(false);
  };

  // const [filteredDocuments, setFilteredDocuments] = useState(documents);

  // useEffect(() => {
  //   const filtered = [];
  //   documents?.forEach((item) => {
  //     if (deal?.status?.id === DEAL_STATUS_WAITING_FOR_PAYMENT || deal?.statusPayment?.id === PAYMENT_STATUS_PAID) {
  //       if (item?.type?.id !== DOCUMENT_TYPES_INVOICE || item?.type?.id === DOCUMENT_TYPES_PAYMENT_CONFIRMATION) {
  //         filtered.push(item);
  //       }
  //     }
  //   });

  //   setFilteredDocuments(filtered);
  // }, [deal, documents]);

  const [rejectModal, setRejectModal] = useState(false);
  const [historyModal, setHistoryModal] = useState(false);
  const onRejectDone = () => {
    update();
  };

  return (
    <div className={styles.DealSteps}>
      <p style={{ ...textStyles.formTitle, marginBottom: 20 }}>ÐÐ¾Ð²Ð°Ñ ÑÐ´ÐµÐ»ÐºÐ°</p>

      <div className={styles.DealStepsContainer} style={{ gridTemplateColumns: 'repeat(' + steps?.length + ', 1fr)' }}>
        {steps.map((step, index) => {
          const activeStep = steps.find((item) => item.subSteps.includes(currentStep));
          const activeStepIndex = steps.indexOf(activeStep);
          const isDone = activeStepIndex > index;
          return (
            <div
              className={`${styles.DealStepsItem} ${index <= activeStepIndex ? styles.DealStepsItem__active : ''}`}
              // onClick={() => setCurrentStep(index + 1)}
            >
              <div className={styles.DealStepsItemNumber}>
                {isDone ? (
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <g clipPath="url(#clip0_3458_54300)">
                      <path
                        d="M10.5 15.172L19.692 5.979L21.107 7.393L10.5 18L4.13599 11.636L5.54999 10.222L10.5 15.172Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_3458_54300">
                        <rect width="24" height="24" fill="white" transform="translate(0.5)" />
                      </clipPath>
                    </defs>
                  </svg>
                ) : (
                  index + 1
                )}
              </div>
              <div className={styles.DealStepsItemText}>{step?.title}</div>
            </div>
          );
        })}
      </div>

      {deal && (
        <>
          <p style={{ ...textStyles.formTitle, marginBottom: 20 }}>ÐÑÐ½Ð¾Ð²Ð½Ð°Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ</p>

          <div className={styles.stepsRow} style={{ marginBottom: 20 }}>
            <p className={styles.stepsRow__name}>ÐÐ»Ð¸ÐµÐ½Ñ:</p>
            <p
              className={styles.stepsRow__value}
              style={{ color: colors?.cameo, textDecoration: 'underline', cursor: 'pointer' }}
              onClick={() => {
                navigateToClient(deal?.client?.id);
              }}
            >
              {deal?.client?.name} {deal?.client?.surname}
            </p>

            <p className={styles.stepsRow__name}>Ð¡ÑÐ°ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸:</p>
            <p className={styles.stepsRow__value}>{deal?.status?.title}</p>

            <p className={styles.stepsRow__name}>Ð¡Ð¿Ð¾ÑÐ¾Ð± Ð¾Ð¿Ð»Ð°ÑÑ:</p>
            <p className={styles.stepsRow__value}>{deal?.paymentType?.title}</p>
            <p className={styles.stepsRow__name}>Ð¡ÑÐ°ÑÑÑ Ð¾Ð¿Ð»Ð°ÑÑ:</p>
            <p className={styles.stepsRow__value}>{deal?.statusPayment?.title}</p>
            <p className={styles.stepsRow__name}>ÐÑÐ²ÐµÑÑÑÐ²ÐµÐ½Ð½ÑÐ¹ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ:</p>
            <p className={styles.stepsRow__value}>
              {deal?.manager ? deal?.manager?.surname + ' ' + deal?.manager?.name : null}
            </p>
            {cars?.length > 0 &&
              cars?.map((car) => {
                return (
                  <>
                    <p className={styles.stepsRow__name}>ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ:</p>
                    <p className={styles.stepsRow__value}>
                      <div
                        key={car.id}
                        style={{ ...textStyles.buttonText, cursor: 'pointer' }}
                        onClick={() => openCarModal(car.id)}
                      >
                        ID{car?.id} {car?.mark} {car?.model} {car?.complect} {car?.year}
                      </div>
                    </p>
                    <p className={styles.stepsRow__name}>VIN:</p>
                    <p className={styles.stepsRow__value}>{car?.vin}</p>
                    {creditAppeal?.createdAt ? (
                      <>
                        <p className={styles.stepsRow__name}>ÐÐ°ÑÐ° Ð¿Ð¾Ð´Ð°ÑÐ¸ Ð·Ð°ÑÐ²ÐºÐ¸ Ð½Ð° ÐºÑÐµÐ´Ð¸Ñ:</p>
                        <p className={styles.stepsRow__value}>{formatDate(creditAppeal?.createdAt)}</p>
                      </>
                    ) : null}
                    {creditAppeal?.vehicle_status ? (
                      <>
                        <p className={styles.stepsRow__name}>ÐÐµÑÐ²Ð¸ÑÐ½Ð°Ñ ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ</p>
                        <p className={styles.stepsRow__value}>{creditAppeal?.vehicle_status == 3 ? 'ÐÐ°' : 'ÐÐµÑ'}</p>
                      </>
                    ) : null}

                    {creditAppeal ? (
                      <>
                        <p className={styles.stepsRow__name}>Ð¡ÑÐ±ÑÐ¸Ð´Ð¸Ñ:</p>
                        <p className={styles.stepsRow__value}>{creditAppeal?.subsidy ? 'ÐÐ°' : 'ÐÐµÑ'}</p>
                      </>
                    ) : null}
                    {creditAppeal ? (
                      <>
                        <p className={styles.stepsRow__name}>ÐÑÐ³Ð¾ÑÐ½Ð¾Ðµ ÐºÑÐµÐ´Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ:</p>
                        <p className={styles.stepsRow__value}>{creditAppeal?.benefit ? 'ÐÐ°' : 'ÐÐµÑ'}</p>
                      </>
                    ) : null}
                    {creditAppeal ? (
                      <>
                        <p className={styles.stepsRow__name}>Ð Ð°ÑÑÑÐ¾ÑÐºÐ°:</p>
                        <p className={styles.stepsRow__value}>{creditAppeal?.grace ? 'ÐÐ°' : 'ÐÐµÑ'}</p>
                      </>
                    ) : null}
                    {creditAppeal ? (
                      <>
                        <p className={styles.stepsRow__name}>Ð¡ÐµÐ¼ÐµÐ¹Ð½Ð¾Ðµ Ð¿Ð¾Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ ÐºÐ»Ð¸ÐµÐ½ÑÐ°:</p>
                        <p className={styles.stepsRow__value}>
                          {MARITAL_STATUSES?.find((item) => item?.value === creditAppeal?.MaritalStatus)?.label}
                        </p>
                      </>
                    ) : null}
                  </>
                );
              })}
            <ChosenBankConditions appeal={chosenBankAppeal} dealId={deal?.id} documents={documents} />
            {chosenBankAppeal?.errorMessage ? (
              <>
                <p className={styles.stepsRow__name}>Ð¡Ð¾Ð¾Ð±ÑÐµÐ½Ð¸Ðµ Ð¾Ñ Ð±Ð°Ð½ÐºÐ°:</p>
                <p className={styles.stepsRow__value}>{chosenBankAppeal?.errorMessage}</p>
              </>
            ) : null}
          </div>
        </>
      )}
      {equipments?.length > 0 && (
        <>
          <p style={{ ...textStyles.formTitle, marginBottom: 20 }}>ÐÐºÑÐµÑÑÑÐ°ÑÑ</p>

          <div
            className={styles.stepsRow}
            style={{ marginBottom: 20, gridTemplateColumns: '150px 1fr 0.5fr auto', alignItems: 'center' }}
          >
            {equipments?.map((item, index) => {
              return (
                <>
                  <p className={styles.stepsRow__name}>ÐÐºÑÐµÑÑÑÐ°ÑÑ {index + 1}:</p>
                  <p
                    className={styles.stepsRow__value}
                    style={{ ...textStyles.buttonText, textDecoration: 'underline' }}
                  >
                    {item?.title} {item?.count > 1 ? `(${item?.count})` : null}
                  </p>
                  <p className={styles.stepsRow__value} style={{ ...textStyles.buttonText, color: '#05141F' }}>
                    {formatNumber(item?.price)}
                  </p>
                  {currentStep <= 3 ? (
                    <ButtonDelete
                      onClick={() => {
                        removeEquipment && removeEquipment(item?.id);
                      }}
                    />
                  ) : (
                    <div></div>
                  )}
                </>
              );
            })}
          </div>
        </>
      )}
      {services?.length > 0 && (
        <>
          <p style={{ ...textStyles.formTitle, marginBottom: 20 }}>ÐÐ¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½ÑÐµ ÑÑÐ»ÑÐ³Ð¸:</p>

          <div
            className={styles.stepsRow}
            style={{ marginBottom: 20, gridTemplateColumns: '150px 1fr 0.5fr auto', alignItems: 'center' }}
          >
            {services?.map((item, index) => {
              return (
                <>
                  <p className={styles.stepsRow__name}>Ð£ÑÐ»ÑÐ³Ð° {index + 1}:</p>
                  <p
                    className={styles.stepsRow__value}
                    style={{ ...textStyles.buttonText, textDecoration: 'underline' }}
                  >
                    {item?.title}
                  </p>
                  <p className={styles.stepsRow__value} style={{ ...textStyles.buttonText, color: '#05141F' }}>
                    {formatNumber(item?.price)}
                  </p>
                  {currentStep <= 3 ? (
                    <ButtonDelete
                      onClick={() => {
                        removeService && removeService(item?.id);
                      }}
                    />
                  ) : (
                    <div></div>
                  )}
                </>
              );
            })}
          </div>
        </>
      )}

      {documents?.length > 0 && currentStep > 5 && <DocumentList documents={documents} />}
      <div style={{ marginBottom: 10 }}>
        {showHalykGetGuaranteeLetterButton && (
          <HalykGetGuaranteeLetter appealId={chosenBankAppealId} onSuccess={update} />
        )}
      </div>
      <div style={{ marginBottom: 10 }}>
        {showForteUpdateButton && <CheckBankStatus chunkId={deal?.chunkId} bankId={chosenBankId} onSuccess={update} />}
      </div>
      <BankAppealsCancelBlock creditAppeals={creditAppeals} deal={deal} update={update} />
      <div
        style={{
          display: 'flex',
          gap: 10,
          flexWrap: 'wrap',
        }}
      >
        {isEurazChosen ? <ProcessDocumentButton chunkId={deal?.chunkId} /> : null}
        {chosenBankId === BANKS.SHINHAN && <ShinhanQRCode qrString={chosenBankAppeal?.qr} update={update} />}
        <Button onClick={() => setHistoryModal(true)}>ÐÑÑÐ¾ÑÐ¸Ñ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ð¹</Button>
        <Button onClick={() => setRejectModal(true)} fill>
          ÐÑÐ¼ÐµÐ½Ð¸ÑÑ ÑÐ´ÐµÐ»ÐºÑ
        </Button>
      </div>
      {sum > 0 && (
        <>
          <hr style={{ border: '1px solid #D9D9D9', margin: '20px 0' }} />
          <div className={styles.stepsRow}>
            <p className={styles.stepsRow__name}>Ð¡ÑÐ¼Ð¼Ð° ÑÐ´ÐµÐ»ÐºÐ¸, KZT:</p>
            <p className={styles.stepsRow__value} style={{ ...textStyles.buttonText, color: '#05141F' }}>
              {formatNumber(sum)}
            </p>
          </div>
        </>
      )}

      <DealConfigureSteps bankId={chosenBankId} dealId={deal?.id} update={update} />

      <DealCarModal isOpen={open} onClose={closeCarModal} containerId={containerId} />
      <RejectDealModal dealId={deal?.id} isOpen={rejectModal} onClose={setRejectModal} onSuccess={onRejectDone} />
      <DealHistoryModal dealId={deal?.id} isOpen={historyModal} onClose={() => setHistoryModal(false)} />
    </div>
  );
};

export default DealCreationSteps;
